export default __webpack_public_path__ + "e2285809b5143c28c0090ebde67542f9.png";